<div class="relative z-10 h-screen flex flex-col mx-auto sm:w-[600px]">

  <div class="h-[30vh] w-full"></div>
  <div class="h-[70vh] mx-4 max-w-2xl flex flex-col justify-center p-2 bg-white rounded-t-2xl" [ngClass]="{
    'animate-slide-up': !isClosing
  }" (animationend)="onAnimationEnd()">
    <div class="w-full p-2 flex-1">
      <div class="flex justify-center w-full mb-4">
        <img src="assets/img/waiting-notes/logo.png" alt="Logo" class="w-24 h-24 rounded-full object-cover">
      </div>
      <div class="bg-white shadow rounded-xl p-4 flex flex-col items-center">
        <h2 class="text-lg sm:text-2xl font-bold text-red-600 uppercase fontPoppins">Note introuvable</h2>
        <h2 class="text-lg sm:text-2xl text-gray-800">{{ data.pointOfSaleName }}</h2>
        <h3 class="text-gray-700 text-lg">Table {{ data.tableNumber }}</h3>
        <h2 class="flex justify-center mx-auto max-w-2xl m-4 w-full">Cette note n’existe pas ou a été supprimée.</h2>
      </div>
    </div>
  </div>
</div>